import { render, staticRenderFns } from "./HighSchool.vue?vue&type=template&id=6186e46e&scoped=true&"
import script from "./HighSchool.vue?vue&type=script&lang=js&"
export * from "./HighSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6186e46e",
  null
  
)

export default component.exports